import { Button, Image, Layout, Space } from "antd";
import React from "react";
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { getCurrentUser, USER_ROLES } from "../../services/User";
import './header.css'

function Header() {

  const navigate = useNavigate();
  const user = getCurrentUser();

  const logout = () => {
    localStorage.removeItem('user')
    navigate('/login')
  }

  const handleUsers =() => {
    if(user.role = USER_ROLES.ADMIN){
      navigate('/admin/users')
    } else {
      navigate(`/admin/users`)
    }
  }

  return (
    <Layout.Header className='header'>
      <Space>
        <Image src='./undp-logo-white.png' height={55} preview={false} />
        <span style={{ fontSize: 'medium' }}>
          Standard Operating Procedures Internal Procurement Processes
        </span>
      </Space>
      <Space>
        {user.role!= USER_ROLES.USER && <Button onClick={() => navigate('')} type='primary'>Home</Button>}
        {user.role!= USER_ROLES.USER && <Button onClick={handleUsers} type='primary'>Users</Button>}
        <span>{user.name}</span>
        <Button onClick={logout} icon={<LogoutOutlined />} shape='circle' type='text' style={{ color: 'white' }} />
      </Space>
    </Layout.Header>
  )
}

export default React.memo(Header);